import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AUcheckbox } from '@gov.au/control-input';

class CheckboxOption extends Component {
    constructor(props) {
        super(props);
        let checkedValue = false

        if (props.existingAnswer) {
            const existingAnswer = props.existingAnswer.checkboxes[props.id];
            if (existingAnswer) {
                checkedValue = existingAnswer.check
            }
        }

        //used by add drone - single checkbox
        if (props.checked) {
            checkedValue = props.checked
        }

        let optionObject = {
            value: this.props.value,
            check: checkedValue,
            optionid: this.props.id,
            questionid: this.props.questionid,
            text: this.props.optionLabel
        }
    
        if (this.props.onChangeFunction) {
            this.props.onChangeFunction(optionObject);
        }

        this.state = {
            checked: checkedValue
        }
    }

    onChange = (e) => {
        this.setState({
            checked: e.target.checked
        })

        let optionObject = {
            value: this.props.value,
            check: e.target.checked,
            optionid: this.props.id,
            questionid: this.props.questionid,
            text: this.props.optionLabel
        }

        if (this.props.returnCheckboxValues) {
            this.props.returnCheckboxValues(optionObject);
        }

        if (this.props.onChangeFunction) {
            this.props.onChangeFunction(optionObject)
        }
    }

    onBlur = (e) => {
        if (this.props.onBlur) {
            this.props.onBlur(e)
        }
    }

    onClick = (e) => {
        e.target.focus()
    }

    createInput = () => {
        switch (this.props.type) {
            case "checkbox":
                return (
                    <AUcheckbox
                        label={this.props.optionLabel}
                        name={this.props.name}
                        id={this.props.id}
                        questionid={this.props.questionid}
                        onClick={this.onClick}
                        onChange={this.onChange}
                        onBlur={this.onBlur}
                        value={this.props.value}
                        aria-describedby={`${this.props.id}-error`}
                        status={this.props.status}
                        block
                        defaultChecked={this.state.checked} />
                )
            default:
                return null;
        }
    }

    render() {
        return (
            this.createInput()
        )
    }
}

CheckboxOption.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    questionid: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    optionLabel: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    defaultChecked: PropTypes.bool.isRequired,
    onChangeFunction: PropTypes.func,
    onBlur: PropTypes.func,
    status: PropTypes.string,
    returnCheckboxValues: PropTypes.func,
    existingAnswer: PropTypes.object,
    returnRadioValue: PropTypes.func,
    returnCheckboxValue: PropTypes.func,
    checked: PropTypes.bool
};

CheckboxOption.defaultProps = {
    defaultChecked: false
};

export default CheckboxOption;